var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClass},[_c('ul',{staticClass:"error-text",class:{ 'mb-0': _vm.marginFlg }},[_c('li',{staticClass:"mb-error-message error"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errors[0])}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }